
const apiErrors_ = [
	'This username does not exist',
	'Password Incorrect',
	'User deleted'
] as const;

export type EndpointPath = typeof apiErrors_[number];

export const apiErrors: { [K in EndpointPath]: K } = Object.fromEntries(
	apiErrors_.map(r => [r, r])
) as { [K in EndpointPath]: K };
